(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    function initBrandCarousel(el) {
      if (el.dataset.brandReady === 'true') return;
      el.dataset.brandReady = 'true';

      var track    = el.querySelector('.brand-carousel__track');
      var viewport = el.querySelector('.brand-carousel__viewport');
      var prevBtn  = el.querySelector('.brand-carousel__btn--prev');
      var nextBtn  = el.querySelector('.brand-carousel__btn--next');

      if (!track) return;

      var items    = Array.from(track.querySelectorAll('.brand-carousel__item'));
      var n        = items.length;
      var current  = 0;
      var autoMs   = parseInt(el.dataset.speed || '3000', 10);
      var timer    = null;
      var busy     = false;

      /* ── Helpers ─────────────────────────────────────────── */

      function getVisible() {
        var w = window.innerWidth;
        if (w <= 480) return 2;
        if (w <= 768) return 3;
        if (w <= 1024) return 4;
        return 6;
      }

      function getStep() {
        /* Width of one item + gap in pixels */
        if (!items[0]) return 0;
        var gap  = parseFloat(getComputedStyle(track).gap) || 24;
        var rect = items[0].getBoundingClientRect();
        return rect.width + gap;
      }

      function maxIndex() {
        return Math.max(0, n - getVisible());
      }

      /* ── Navigation ──────────────────────────────────────── */

      function slideTo(idx, animated) {
        var step   = getStep();
        var max    = maxIndex();
        current    = Math.max(0, Math.min(idx, max));
        var offset = current * step;

        if (animated === false) {
          track.style.transition = 'none';
        } else {
          track.style.transition = 'transform 500ms ease';
        }
        track.style.transform = 'translateX(-' + offset + 'px)';
      }

      function next() {
        if (busy) return;
        if (current >= maxIndex()) {
          /* At end: snap back to 0 (no animation so it's instant) */
          slideTo(0, false);
        } else {
          slideTo(current + 1, true);
        }
      }

      function prev() {
        if (busy) return;
        if (current <= 0) {
          slideTo(maxIndex(), true);
        } else {
          slideTo(current - 1, true);
        }
      }

      /* ── Autoplay ────────────────────────────────────────── */

      function startAuto() {
        clearInterval(timer);
        timer = setInterval(next, autoMs);
      }

      function stopAuto() {
        clearInterval(timer);
        timer = null;
      }

      /* ── Events ──────────────────────────────────────────── */

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          prev();
          startAuto(); /* reset timer on manual nav */
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          next();
          startAuto();
        });
      }

      el.addEventListener('mouseenter', stopAuto);
      el.addEventListener('mouseleave', startAuto);

      /* Re-clamp position on resize */
      var resizeDebounce;
      window.addEventListener('resize', function () {
        clearTimeout(resizeDebounce);
        resizeDebounce = setTimeout(function () {
          slideTo(Math.min(current, maxIndex()), false);
        }, 150);
      });

      /* ── Init ────────────────────────────────────────────── */
      slideTo(0, false);
      startAuto();
    }

    /* Bootstrap on DOMContentLoaded or immediately if already loaded */
    function boot() {
      document.querySelectorAll('.brand-carousel').forEach(initBrandCarousel);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    'use strict';

    var linesEl  = document.getElementById('vk-cart-lines');
    if (!linesEl) return;

    var subtotalEl  = document.querySelector('[data-cart-subtotal]');
    var totalEl     = document.querySelector('[data-cart-total]');
    var countEl     = document.querySelector('[data-cart-item-count]');
    var updateTimer = null;

    /* ── Money formatter (matches Shopify $X.XX format) ── */
    function money(cents) {
      var n = (cents / 100).toFixed(2);
      var parts = n.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return '$' + parts.join('.');
    }

    /* ── Lock / unlock an item row during AJAX ── */
    function lockItem(itemEl) {
      itemEl.classList.add('vk-cart-item--updating');
      itemEl.querySelectorAll('.vk-cart-item__qty-btn').forEach(function (b) { b.disabled = true; });
    }

    function unlockItem(itemEl) {
      itemEl.classList.remove('vk-cart-item--updating');
      itemEl.querySelectorAll('.vk-cart-item__qty-btn').forEach(function (b) { b.disabled = false; });
    }

    /* ── AJAX cart update via Shopify Cart API ── */
    function updateCartItem(key, quantity) {
      var itemEl = linesEl.querySelector('.vk-cart-item[data-key="' + key + '"]');
      if (itemEl) lockItem(itemEl);

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart API error ' + res.status);
        return res.json();
      })
      .then(function (cart) {

        /* Update global totals */
        var fmt = money(cart.total_price);
        if (subtotalEl) subtotalEl.textContent = fmt;
        if (totalEl)    totalEl.textContent    = fmt;

        var stickyTotalEl = document.querySelector('[data-cart-sticky-total]');
        if (stickyTotalEl) stickyTotalEl.textContent = fmt;

        /* Update instalment message (Afterpay limits are read from the element) */
        var bnplEl = document.querySelector('[data-cart-bnpl]');
        if (bnplEl) {
          var bMin = Number(bnplEl.getAttribute('data-bnpl-min'));
          var bMax = Number(bnplEl.getAttribute('data-bnpl-max'));
          var bAmt = bnplEl.querySelector('[data-cart-bnpl-amount]');
          if (bAmt) bAmt.textContent = money(Math.round(cart.total_price / 4));
          bnplEl.hidden = !(cart.total_price >= bMin && cart.total_price <= bMax);
          var ppEl = bnplEl.querySelector('[data-cart-bnpl-paypal]');
          if (ppEl) {
            ppEl.hidden = !(cart.total_price >= Number(ppEl.getAttribute('data-pp-min')) &&
                            cart.total_price <= Number(ppEl.getAttribute('data-pp-max')));
          }
        }

        /* Update item count in header */
        if (countEl) {
          var n = cart.item_count;
          countEl.textContent = '(' + n + ' ' + (n === 1 ? 'item' : 'items') + ')';
        }

        /* Update surviving line totals */
        cart.items.forEach(function (ci) {
          var el = linesEl.querySelector('[data-line-total="' + ci.key + '"]');
          if (el) el.textContent = money(ci.line_price);
        });

        /* Remove row when quantity reached 0 */
        if (quantity === 0 && itemEl) {
          itemEl.classList.add('vk-cart-item--removing');
          setTimeout(function () {
            if (itemEl.parentNode) itemEl.parentNode.removeChild(itemEl);
          }, 280);
        } else if (itemEl) {
          unlockItem(itemEl);
        }

        /* Reload page when cart is empty so empty-state renders */
        if (cart.item_count === 0) {
          window.location.reload();
        }
      })
      .catch(function () {
        /* On error: unlock and reload so user sees real state */
        if (itemEl) unlockItem(itemEl);
        window.location.reload();
      });
    }

    /* ── Qty stepper buttons ── */
    linesEl.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty-delta]');
      if (!btn) return;

      var row   = btn.closest('.vk-cart-item');
      var input = row && row.querySelector('[data-qty-key]');
      if (!input) return;

      var delta  = parseInt(btn.getAttribute('data-qty-delta'), 10);
      var newQty = Math.max(0, Math.min(99, (parseInt(input.value, 10) || 0) + delta));
      input.value = newQty;

      clearTimeout(updateTimer);
      var key = input.getAttribute('data-qty-key');
      updateTimer = setTimeout(function () { updateCartItem(key, newQty); }, 320);
    });

    /* ── Direct input edit ── */
    linesEl.addEventListener('change', function (e) {
      var input = e.target.closest('[data-qty-key]');
      if (!input) return;

      var newQty = Math.max(0, Math.min(99, parseInt(input.value, 10) || 0));
      input.value = newQty;

      clearTimeout(updateTimer);
      var key = input.getAttribute('data-qty-key');
      updateTimer = setTimeout(function () { updateCartItem(key, newQty); }, 320);
    });

    /* ── Remove buttons ── */
    linesEl.addEventListener('click', function (e) {
      var removeBtn = e.target.closest('[data-remove]');
      if (!removeBtn) return;

      e.preventDefault();
      var key = removeBtn.getAttribute('data-remove');
      clearTimeout(updateTimer);
      updateCartItem(key, 0);
    });

    /* ── Cart note auto-save (debounced) ── */
    var noteEl    = document.querySelector('[data-cart-note]');
    var noteTimer = null;

    if (noteEl) {
      noteEl.addEventListener('input', function () {
        clearTimeout(noteTimer);
        noteTimer = setTimeout(function () {
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ note: noteEl.value })
          });
        }, 800);
      });
    }

  })();

  /* ── Sticky Checkout bar: only shown while the main Checkout button is off screen ── */
  (function () {
    var btn = document.querySelector('.vk-cart-summary__checkout');
    var bar = document.querySelector('[data-cart-sticky]');
    if (!btn || !bar) return;
    if (!('IntersectionObserver' in window)) { bar.classList.add('is-visible'); return; }
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { bar.classList.toggle('is-visible', !e.isIntersecting); });
    }, { threshold: 0 }).observe(btn);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deal-of-day"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    function startTimer(timerEl) {
      var endDateStr = timerEl.getAttribute('data-countdown');
      if (!endDateStr) return;

      var endTime = new Date(endDateStr).getTime();
      if (isNaN(endTime)) return;

      function pad(n) { return String(n).padStart(2, '0'); }

      function tick() {
        var remaining = endTime - Date.now();
        if (remaining <= 0) remaining = 0;

        var d = Math.floor(remaining / 86400000);
        var h = Math.floor((remaining % 86400000) / 3600000);
        var m = Math.floor((remaining % 3600000) / 60000);
        var s = Math.floor((remaining % 60000) / 1000);

        var map = { days: d, hours: h, minutes: m, seconds: s };
        Object.keys(map).forEach(function (key) {
          var el = timerEl.querySelector('[data-timer="' + key + '"]');
          if (el) el.textContent = pad(map[key]);
        });
      }

      tick();
      if (endTime > Date.now()) setInterval(tick, 1000);
    }

    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('.dod__timer[data-countdown]').forEach(startTimer);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  void 0;

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    class HeroSlider {
      constructor(element) {
        /* Guard: skip if already initialised */
        if (element.dataset.sliderReady === 'true') return;
        element.dataset.sliderReady = 'true';

        this.el        = element;
        this.wrapper   = element.querySelector('.hero-slider__wrapper');
        this.slides    = Array.from(element.querySelectorAll('.hero-slider__slide'));
        this.dots      = Array.from(element.querySelectorAll('.hero-slider__dot'));
        this.prevBtn   = element.querySelector('.hero-slider__arrow--prev');
        this.nextBtn   = element.querySelector('.hero-slider__arrow--next');
        this.speed     = (parseInt(element.dataset.autoplaySpeed || '5', 10) || 5) * 1000;
        this._interval = null;
        this._current  = 0;
        this._resizeTimer = null;

        var activeIndex = this.slides.findIndex(function (s) {
          return s.classList.contains('is-active');
        });
        this._current = activeIndex >= 0 ? activeIndex : 0;

        this._applyState();
        this._bindEvents();
        this._updateMobileHeight();

        if (this.slides.length > 1) {
          this._startAutoplay();
        }
      }

      /* Sizes the wrapper to match the active slide's image aspect ratio on
         mobile, so "contain" images fill it exactly with no empty bars. */
      _updateMobileHeight() {
        if (!this.wrapper) return;

        if (!window.matchMedia('(max-width: 768px)').matches) {
          this.wrapper.style.removeProperty('--mobile-height');
          return;
        }

        var activeSlide = this.slides[this._current];
        if (!activeSlide) return;

        var ratioWidth  = parseFloat(activeSlide.dataset.imgWidth);
        var ratioHeight = parseFloat(activeSlide.dataset.imgHeight);
        if (!ratioWidth || !ratioHeight) return;

        var containerWidth = this.wrapper.getBoundingClientRect().width;
        if (!containerWidth) return;

        var height = containerWidth / (ratioWidth / ratioHeight);
        height = Math.max(160, Math.min(460, height));
        this.wrapper.style.setProperty('--mobile-height', Math.round(height) + 'px');
      }

      goTo(index) {
        if (index === this._current) return;
        this._current = index;
        this._applyState();
        this._updateMobileHeight();
        this._restartAutoplay();
      }

      next() {
        this.goTo((this._current + 1) % this.slides.length);
      }

      prev() {
        this.goTo((this._current - 1 + this.slides.length) % this.slides.length);
      }

      _applyState() {
        var current = this._current;
        this.slides.forEach(function (slide, i) {
          var active = i === current;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        this.dots.forEach(function (dot, i) {
          var active = i === current;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
      }

      _startAutoplay() {
        /* Always clear before creating — prevents duplicate intervals */
        clearInterval(this._interval);
        var self = this;
        this._interval = setInterval(function () { self.next(); }, self.speed);
      }

      _stopAutoplay() {
        clearInterval(this._interval);
        this._interval = null;
      }

      _restartAutoplay() {
        this._startAutoplay();
      }

      _bindEvents() {
        var self = this;

        if (this.prevBtn) {
          this.prevBtn.addEventListener('click', function () { self.prev(); });
        }
        if (this.nextBtn) {
          this.nextBtn.addEventListener('click', function () { self.next(); });
        }

        this.dots.forEach(function (dot, i) {
          dot.addEventListener('click', function () { self.goTo(i); });
        });

        this.el.addEventListener('mouseenter', function () { self._stopAutoplay(); });
        this.el.addEventListener('mouseleave', function () {
          if (self.slides.length > 1) self._startAutoplay();
        });

        this.el.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowLeft')  { e.preventDefault(); self.prev(); }
          if (e.key === 'ArrowRight') { e.preventDefault(); self.next(); }
        });

        window.addEventListener('resize', function () {
          clearTimeout(self._resizeTimer);
          self._resizeTimer = setTimeout(function () {
            self._updateMobileHeight();
          }, 150);
        });
      }
    }

    function initSliders() {
      document.querySelectorAll('.hero-slider').forEach(function (el) {
        new HeroSlider(el);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initSliders);
    } else {
      initSliders();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (function () {
    'use strict';

    var form     = document.getElementById('collection-filters-form');
    var sidebar  = document.getElementById('collection-sidebar');
    var overlay  = document.querySelector('[data-filter-overlay]');
    var toggle   = document.querySelector('[data-filter-toggle]');
    var closeBtn = document.querySelector('[data-filter-close]');
    var sortSel  = document.querySelector('[data-sort-select]');
    var grid     = document.getElementById('collection-products');
    var viewBtns = document.querySelectorAll('[data-view]');

    /* ── Sidebar open / close ─────────────────────── */
    function openSidebar() {
      if (!sidebar) return;
      sidebar.classList.add('is-open');
      if (overlay) { overlay.classList.add('is-open'); overlay.removeAttribute('aria-hidden'); }
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function closeSidebar() {
      if (!sidebar) return;
      sidebar.classList.remove('is-open');
      if (overlay) { overlay.classList.remove('is-open'); overlay.setAttribute('aria-hidden', 'true'); }
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    if (toggle)   toggle.addEventListener('click', openSidebar);
    if (closeBtn) closeBtn.addEventListener('click', closeSidebar);
    if (overlay)  overlay.addEventListener('click', closeSidebar);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sidebar && sidebar.classList.contains('is-open')) {
        closeSidebar();
      }
    });

    /* ── Filter checkboxes: submit on change ─────── */
    if (form) {
      form.querySelectorAll('[data-filter-input]').forEach(function (input) {
        input.addEventListener('change', function () { form.submit(); });
      });
    }

    /* ── Sort select: submit on change ───────────── */
    if (sortSel) {
      sortSel.addEventListener('change', function () {
        if (form) form.submit();
      });
    }

    /* ── Price inputs: submit on blur / Enter ────── */
    if (form) {
      var priceTimer;
      form.querySelectorAll('[data-filter-price]').forEach(function (input) {
        input.addEventListener('change', function () {
          clearTimeout(priceTimer);
          priceTimer = setTimeout(function () { form.submit(); }, 400);
        });
        input.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') { e.preventDefault(); form.submit(); }
        });
      });
    }

    /* ── Grid / list view toggle ─────────────────── */
    function setView(view) {
      if (grid) grid.setAttribute('data-view', view);
      viewBtns.forEach(function (btn) {
        var active = btn.getAttribute('data-view') === view;
        btn.classList.toggle('active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      try { sessionStorage.setItem('vek-collection-view', view); } catch (e) {}
    }

    viewBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setView(btn.getAttribute('data-view'));
      });
    });

    /* Restore saved view preference */
    try {
      var saved = sessionStorage.getItem('vek-collection-view');
      if (saved && (saved === 'grid' || saved === 'list')) setView(saved);
    } catch (e) {}

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductGallery {
    constructor() {
      this.thumbnails = document.querySelectorAll('[data-thumbnail]');
      this.mainImage = document.querySelector('[data-main-image]');
      this.init();
    }

    init() {
      this.thumbnails.forEach(thumb => {
        thumb.addEventListener('click', (e) => this.handleThumbnailClick(e));
      });
    }

    handleThumbnailClick(e) {
      const fullSrc = e.currentTarget.getAttribute('data-full-src');

      this.thumbnails.forEach(t => t.classList.remove('active'));
      e.currentTarget.classList.add('active');

      if (fullSrc && this.mainImage) {
        this.mainImage.src = fullSrc;
      }
    }
  }

  class ProductTabs {
    constructor() {
      this.tabs = document.querySelectorAll('[data-tab]');
      this.panels = document.querySelectorAll('[data-tab-panel]');
      this.init();
    }

    init() {
      this.tabs.forEach(tab => {
        tab.addEventListener('click', (e) => this.handleTabClick(e));
      });
    }

    handleTabClick(e) {
      const tabName = e.currentTarget.getAttribute('data-tab');
      
      this.tabs.forEach(t => t.classList.remove('active'));
      this.panels.forEach(p => p.classList.remove('active'));
      
      e.currentTarget.classList.add('active');
      const panel = document.querySelector(`[data-tab-panel="${tabName}"]`);
      if (panel) panel.classList.add('active');
    }
  }

  class ProductQuantity {
    constructor() {
      this.input = document.querySelector('[id="quantity"]');
      this.decreaseBtn = document.querySelector('[data-quantity-decrease]');
      this.increaseBtn = document.querySelector('[data-quantity-increase]');
      this.init();
    }

    init() {
      if (this.decreaseBtn) this.decreaseBtn.addEventListener('click', () => this.decrease());
      if (this.increaseBtn) this.increaseBtn.addEventListener('click', () => this.increase());
    }

    decrease() {
      const current = parseInt(this.input.value) || 1;
      this.input.value = Math.max(1, current - 1);
    }

    increase() {
      const current = parseInt(this.input.value) || 1;
      this.input.value = current + 1;
    }
  }

  class ProductVariantSelector {
    constructor() {
      this.form        = document.getElementById('product-main-form');
      this.variantInput = document.getElementById('product-variant-id');
      this.addToCartBtn = this.form && this.form.querySelector('.product__add-to-cart');

      var dataEl = document.getElementById('product-variants-data');
      this.variants = dataEl ? JSON.parse(dataEl.textContent) : [];

      if (!this.form || !this.variantInput || !this.variants.length) return;
      this._init();
    }

    _init() {
      // Listen on all option selects
      this.form.querySelectorAll('.product__option-select').forEach(sel => {
        sel.addEventListener('change', () => this._update());
      });
      // Listen on color/swatch radio buttons
      this.form.querySelectorAll('.product__option-swatch').forEach(radio => {
        radio.addEventListener('change', () => this._update());
      });
    }

    _selectedOptions() {
      var values = [];
      this.form.querySelectorAll('.product__option-group').forEach(group => {
        var sel   = group.querySelector('.product__option-select');
        var radio = group.querySelector('.product__option-swatch:checked');
        if (sel)   values.push(sel.value);
        else if (radio) values.push(radio.value);
      });
      return values;
    }

    _findVariant(opts) {
      return this.variants.find(v =>
        v.options.every((opt, i) => opt === opts[i])
      );
    }

    _update() {
      var opts    = this._selectedOptions();
      var variant = this._findVariant(opts);
      if (!variant) return;

      // Update hidden variant ID — this is what Shopify reads on submit
      this.variantInput.value = variant.id;

      // Sync button state
      if (this.addToCartBtn) {
        this.addToCartBtn.disabled = !variant.available;
      }

      // Sync price display
      var priceEl = document.querySelector('.product__price-current');
      if (priceEl && variant.price != null) {
        var formatted = (variant.price / 100).toLocaleString('en-AU', {
          style: 'currency', currency: 'AUD'
        });
        priceEl.textContent = formatted;
      }

      // Sync instalment message (Afterpay limits are read from the element)
      var bnplEl = document.querySelector('[data-bnpl]');
      if (bnplEl && variant.price != null) {
        var bMin = Number(bnplEl.getAttribute('data-bnpl-min'));
        var bMax = Number(bnplEl.getAttribute('data-bnpl-max'));
        var bAmt = bnplEl.querySelector('[data-bnpl-amount]');
        if (bAmt) {
          bAmt.textContent = (variant.price / 400).toLocaleString('en-AU', {
            style: 'currency', currency: 'AUD'
          });
        }
        bnplEl.hidden = !(variant.price >= bMin && variant.price <= bMax);
        var ppEl = bnplEl.querySelector('[data-bnpl-paypal]');
        if (ppEl) {
          ppEl.hidden = !(variant.price >= Number(ppEl.getAttribute('data-pp-min')) &&
                          variant.price <= Number(ppEl.getAttribute('data-pp-max')));
        }
      }

      // Sync compare-at price
      var compareEl = document.querySelector('.product__price-compare');
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          var compareFormatted = (variant.compare_at_price / 100).toLocaleString('en-AU', {
            style: 'currency', currency: 'AUD'
          });
          compareEl.textContent = compareFormatted;
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
    }
  }

  (function () {
    function pmfOpen(modal) {
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var card = modal.querySelector('.pmf-modal__card');
      if (!card) return;
      var focusable = card.querySelector(
        'a[href], button:not([disabled]), input:not([disabled]), ' +
        'select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
      if (focusable) focusable.focus();
    }

    function pmfClose(modal) {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      var openBtn = document.querySelector('[data-price-match-open]');
      if (openBtn) openBtn.focus();
    }

    document.addEventListener('click', function (event) {
      var modal = document.querySelector('[data-price-match-modal]');
      if (!modal) return;
      if (event.target.closest('[data-price-match-open]')) {
        event.preventDefault();
        pmfOpen(modal);
        return;
      }
      if (event.target.closest('[data-price-match-close]')) {
        event.preventDefault();
        pmfClose(modal);
        return;
      }
      if (event.target.closest('[data-price-match-overlay]')) {
        pmfClose(modal);
        return;
      }
    });

    document.addEventListener('keydown', function (event) {
      var modal = document.querySelector('[data-price-match-modal]');
      if (!modal || !modal.classList.contains('is-open')) return;
      if (event.key === 'Escape') {
        pmfClose(modal);
        return;
      }
      if (event.key === 'Tab') {
        var card = modal.querySelector('.pmf-modal__card');
        if (!card) return;
        var els = Array.from(card.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), ' +
          'select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )).filter(function (el) { return !el.closest('[hidden]'); });
        if (els.length === 0) return;
        var first = els[0];
        var last  = els[els.length - 1];
        if (event.shiftKey) {
          if (document.activeElement === first) { event.preventDefault(); last.focus(); }
        } else {
          if (document.activeElement === last)  { event.preventDefault(); first.focus(); }
        }
      }
    });

    // Auto-open after successful form submission (Shopify reloads the page)
    document.addEventListener('DOMContentLoaded', function () {
      var modal = document.querySelector('[data-price-match-modal]');
      if (modal && modal.querySelector('[data-pmf-success]')) {
        pmfOpen(modal);
      }
    });
  }());

  document.addEventListener('DOMContentLoaded', () => {
    new ProductGallery();
    new ProductTabs();
    new ProductQuantity();
    new ProductVariantSelector();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["order-notification"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    var popup  = document.getElementById('order-notification');
    var dataEl = document.getElementById('on-data');
    if (!popup || !dataEl) return;

    /* ── Parse notification items ────────────────────────────── */
    var items;
    try {
      items = JSON.parse(dataEl.textContent.trim());
    } catch (e) {
      return;
    }
    if (!items || !items.length) return;

    /* ── Read timing config from data attributes ─────────────── */
    var cfg = {
      initialDelay:    parseInt(popup.dataset.delay    || '5',  10) * 1000,
      visibleDuration: parseInt(popup.dataset.visible  || '8',  10) * 1000,
      interval:        parseInt(popup.dataset.interval || '20', 10) * 1000,
      pauseDuration:   parseInt(popup.dataset.pause    || '60', 10) * 1000
    };

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* ── DOM refs ─────────────────────────────────────────────── */
    var dom = {
      media:    popup.querySelector('.on-popup__media'),
      img:      popup.querySelector('.on-popup__img'),
      title:    popup.querySelector('.on-popup__title'),
      location: popup.querySelector('.on-popup__location'),
      time:     popup.querySelector('.on-popup__time'),
      close:    popup.querySelector('.on-popup__close')
    };

    /* ── State ────────────────────────────────────────────────── */
    var current    = 0;
    var paused     = false;
    var hideTimer  = null;
    var gapTimer   = null;
    var pauseTimer = null;

    /* ── Helpers ──────────────────────────────────────────────── */

    function updateContent(item) {
      if (dom.img) {
        if (item.img) {
          dom.img.src = item.img;
          dom.img.alt = item.title || '';
          dom.img.style.display = '';
        } else {
          dom.img.style.display = 'none';
        }
      }
      if (dom.media)    dom.media.href         = item.url      || '#';
      if (dom.title)  { dom.title.textContent  = item.title    || ''; dom.title.href = item.url || '#'; }
      if (dom.location) dom.location.textContent = item.location || '';
      if (dom.time)     dom.time.textContent     = item.time     || '';
    }

    function show(item, onAutoHide) {
      updateContent(item);

      /* Remove [hidden] so the element goes from display:none → block */
      popup.removeAttribute('hidden');

      if (reducedMotion) {
        popup.classList.add('on-popup--visible');
      } else {
        /* Flush layout so the initial opacity:0 state is painted,
           then add the class on the next frame to trigger the transition */
        popup.offsetHeight;
        requestAnimationFrame(function () {
          popup.classList.add('on-popup--visible');
        });
      }

      clearTimeout(hideTimer);
      hideTimer = setTimeout(function () {
        hide(onAutoHide);
      }, cfg.visibleDuration);
    }

    function hide(cb) {
      popup.classList.remove('on-popup--visible');
      clearTimeout(hideTimer);

      /* Wait for CSS transition before adding [hidden] again */
      var delay = reducedMotion ? 0 : 380;
      setTimeout(function () {
        popup.setAttribute('hidden', '');
        if (typeof cb === 'function') cb();
      }, delay);
    }

    /* ── Cycle ────────────────────────────────────────────────── */

    function showNext(idx) {
      if (paused) return;

      var item = items[idx % items.length];

      show(item, function () {
        /* After the popup hides, wait the gap time then show the next */
        var gap = Math.max(500, cfg.interval - cfg.visibleDuration);
        clearTimeout(gapTimer);
        gapTimer = setTimeout(function () {
          if (!paused) {
            current = (idx + 1) % items.length;
            showNext(current);
          }
        }, gap);
      });
    }

    /* ── Close button ─────────────────────────────────────────── */

    if (dom.close) {
      dom.close.addEventListener('click', function () {
        clearTimeout(hideTimer);
        clearTimeout(gapTimer);
        paused = true;

        hide();

        /* Pause then resume with the next notification */
        clearTimeout(pauseTimer);
        pauseTimer = setTimeout(function () {
          paused  = false;
          current = (current + 1) % items.length;
          showNext(current);
        }, cfg.pauseDuration);
      });
    }

    /* ── Kick off after initial delay ────────────────────────── */

    setTimeout(function () {
      showNext(0);
    }, cfg.initialDelay);

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-faqs"]) return;
  try {
    
  (function () {
    var list = document.getElementById('faq-list');
    if (!list) return;

    var buttons = list.querySelectorAll('.page-faqs__question');

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        var answerId = btn.getAttribute('aria-controls');
        var answer = document.getElementById(answerId);

        if (expanded) {
          btn.setAttribute('aria-expanded', 'false');
          answer.hidden = true;
        } else {
          btn.setAttribute('aria-expanded', 'true');
          answer.hidden = false;
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initRecommendations = () => {
      document
        .querySelectorAll('.product-recommendations[data-recommendations-url]')
        .forEach((section) => {
          if (section.dataset.recommendationsLoaded === 'true') return;

          const loadRecommendations = () => {
            section.dataset.recommendationsLoaded = 'true';

            fetch(section.dataset.recommendationsUrl)
              .then((response) => {
                if (!response.ok) throw new Error('Unable to load recommendations');
                return response.text();
              })
              .then((text) => {
                const html = document.createElement('div');
                html.innerHTML = text;
                const replacement = html.querySelector('.product-recommendations');

                if (replacement && replacement.innerHTML.trim().length) {
                  section.innerHTML = replacement.innerHTML;
                } else {
                  section.remove();
                }
              })
              .catch(() => {
                section.remove();
              });
          };

          if ('IntersectionObserver' in window) {
            const observer = new IntersectionObserver(
              (entries) => {
                if (!entries[0].isIntersecting) return;
                observer.disconnect();
                loadRecommendations();
              },
              { rootMargin: '0px 0px 300px 0px' }
            );
            observer.observe(section);
          } else {
            loadRecommendations();
          }
        });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initRecommendations, { once: true });
    } else {
      initRecommendations();
    }

    document.addEventListener('shopify:section:load', initRecommendations);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  (function () {
    'use strict';

    /* Sort select: reloads with updated sort_by, resets to page 1 */
    var sortSelect = document.getElementById('srp-sort');
    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', this.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-brand"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    /* Smooth-scroll A–Z anchors with scroll-margin-top already handling offset */
    document.querySelectorAll('.sbr__az-link--active[href^="#"]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var target = document.getElementById(link.getAttribute('href').slice(1));
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["specials-collection-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    // Sort select — preserve current URL params, reset to page 1
    var sortSelect = document.querySelector('[data-scp-sort]');
    if (!sortSelect) return;

    // Reflect current sort_by in the select
    var params = new URLSearchParams(window.location.search);
    var currentSort = params.get('sort_by');
    if (currentSort) sortSelect.value = currentSort;

    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
